import request from "@/utils/request.js"

/**
 * 商品管理
 */
const goods = {
    list: params => request.post("/api/Mall/Goods/GetList", params),
    info: params => request.get("/api/Mall/Goods/GetInfo", { params }),
    submit: params => request.post("/api/Mall/Goods/Submit", params),
    delete: params => request.get("/api/Mall/Goods/Delete", { params }),
    getItems: params => request.get("/api/Mall/Goods/GetItems", { params }),
    setItems: params => request.post("/api/Mall/Goods/SetItems", params),
}

/**
 * 订单管理
 */
const order = {
    list: params => request.post("/api/Mall/Order/GetList", params),
    submit: params => request.post("/api/Mall/Order/Submit", params),
    info: params => request.get("/api/Mall/Order/GetInfo", { params }),
    delete: params => request.get("/api/Mall/Order/Delete", { params }),
    confirm: params => request.get("/api/Mall/Order/Confirm", { params }),
    recall: params => request.get("/api/Mall/Order/Recall", { params }),
    revoke: params => request.get("/api/Mall/Order/Revoke", { params }),
    approval: params => request.get("/api/Mall/Order/Approval", { params }),
    printime: params => request.get("/api/Mall/Order/Printime", { params }),
    download: params => request.post("/api/Mall/Order/Download", params, { responseType: 'blob' }),
    statis: {
        state: params => request.post("/api/Mall/Order/GroupByState", params || {}),
    },
    item: {
        list: params => request.post("/api/Mall/Order/GetItems", params),
        setting: params => request.post("/api/Mall/Order/Setting", params),
        parcels: params => request.get("/api/Mall/Parcel/GetItems", { params }),
        download: params => request.post("/api/Mall/Order/Items/Download", params, { responseType: 'blob' }),
    }
}

/**
 * 发货单管理
 */
const parcel = {
    list: params => request.post("/api/Mall/Parcel/GetList", params),
    submit: params => request.post("/api/Mall/Parcel/Submit", params),
    info: params => request.get("/api/Mall/Parcel/GetDetail", { params }),
    revoke: params => request.get("/api/Mall/Parcel/Revoke", { params }),
    confirm: params => request.post("/api/Mall/Parcel/Confirm", params),
    sign: params => request.get("/api/Mall/Parcel/Sign", { params }),
    printime: params => request.get("/api/Mall/Parcel/Printime", { params }),
    download: params => request.post("/api/Mall/Parcel/Download", params, { responseType: 'blob' }),
    statis: {
        state: params => request.post("/api/Mall/Parcel/GroupByState", params || {}),
    },
}

/**
 * 过单管理
 */
const torder = {
    list: params => request.post("/api/Mall/Torder/GetList", params),
    submit: params => request.post("/api/Mall/Torder/Submit", params),
    info: params => request.get("/api/Mall/Torder/GetInfo", { params }),
    revoke: params => request.get("/api/Mall/Torder/Revoke", { params }),
    delete: params => request.get("/api/Mall/Torder/Delete", { params }),
    confirm: params => request.get("/api/Mall/Torder/Confirm", { params }),
    approve: params => request.get("/api/Mall/Torder/Approve", { params }),
    collect: params => request.get("/api/Mall/Torder/Collect", { params }),
    complete: params => request.post("/api/Mall/Torder/Complete", params),
    statis: {
        state: params => request.post("/api/Mall/Torder/GroupByState", params || {}),
    },
}


export default {
    goods,
    order,
    parcel,
    torder
}